<article class="hd-planet-card"
         [class.hd-planet-card--compact]="compact()"
         [style.--planet-stripe-color]="config().stripeColor">
  <header class="hd-planet-card__header">
    <span class="hd-planet-card__glyph">{{ config().astronomiconChar }}</span>
    <span class="hd-planet-card__name">{{ translations().name }}</span>
    @if (!hideCycleInfo() && cycleSegments().length > 0) {
      <span class="hd-planet-card__cycle">
        @for (seg of cycleSegments(); track $index) {
          @if (seg.extraText) {
            <span class="hd-planet-card__cycle-extra">{{ seg.extraText }}</span>
          } @else {
            <span class="hd-planet-card__cycle-segment">
              <span class="hd-planet-card__cycle-value">{{ seg.value }}</span>
              <span class="hd-planet-card__cycle-unit">{{ seg.unitKey }}</span>
            </span>
          }
        }
      </span>
    }
  </header>

  @if (!hideSubtitle() && translations().subtitle) {
    <div class="hd-planet-card__subtitle">{{ translations().subtitle }}</div>
  }

  @if (!hideBullets() && translations().bullets.length > 0) {
    <ul class="hd-planet-card__bullets">
      @for (bullet of translations().bullets; track $index) {
        <li>{{ bullet }}</li>
      }
    </ul>
  }

  @if (translations().footerTagline) {
    <footer class="hd-planet-card__footer">{{ translations().footerTagline }}</footer>
  }
</article>
